<template>
  <div v-if="api_data.Farmer" id="operationFamilyInformation">
    <div class="card rounded-0 card-custom gutter-b">
      <family-count
          v-bind:api_data="api_data"
      ></family-count>
      <div class="card-body pt-2">
        <div class="form-group">
          <label>{{ $t("Family") }} {{ $t("Male") }} ({{ $t("Adult") }})</label>
          <div class="input-group">
            <input type="number" class="form-control" v-model="api_data.Farmer.family_male">
            <div class="input-group-append">
              <div class="btn btn-primary" type="button">{{ api_data.Farmer.family_male || '0' }}</div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>{{ $t("Family") }} {{ $t("Female") }} ({{ $t("Adult") }})</label>
          <div class="input-group">
            <input type="number" class="form-control" v-model="api_data.Farmer.family_female">
            <div class="input-group-append">
              <div class="btn btn-info" type="button">{{ api_data.Farmer.family_female || '0' }}</div>
            </div>
          </div>
        </div>
        <table class="table">
          <thead class="thead-light">
          <tr>
            <th scope="col">{{ $t("Particular") }}</th>
            <th scope="col">{{ $t("Count") }}</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th scope="row">{{ $t("Female") }} {{ $t("SHG Member") }}</th>
            <td>
              <div class="input-group">
                <input type="number" class="form-control"
                       v-model="api_data.Farmer.family_female_shg_member"
                       :max="api_data.Farmer.family_female"
                >

                <div class="input-group-append">
                  <div class="btn btn-warning" type="button">
                    {{ api_data.Farmer.family_female_shg_member || '0' }}
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">{{ $t("Children") }} ({{ $t("Boy") }})</th>
            <td>
              <div class="input-group">
                <input type="number" class="form-control" v-model="api_data.Farmer.family_boy">
                <div class="input-group-append">
                  <div class="btn btn-warning" type="button">
                    {{ api_data.Farmer.family_boy || '0' }}
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">{{ $t("Children") }} ({{ $t("Boy") }} {{ $t("Play Group") }})</th>
            <td>
              <div class="input-group">
                <input type="number" class="form-control" v-model="api_data.Farmer.family_boy_playgroup"
                       :max="api_data.Farmer.family_boy"
                >
                <div class="input-group-append">
                  <div class="btn btn-warning" type="button">
                    {{ api_data.Farmer.family_boy_playgroup || '0' }}
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">{{ $t("Children") }} ({{ $t("Boy") }} {{ $t("School") }})</th>
            <td>
              <div class="input-group">
                <input type="number" class="form-control" v-model="api_data.Farmer.family_boy_school"
                       :max="api_data.Farmer.family_boy"
                >
                <div class="input-group-append">
                  <div class="btn btn-warning" type="button">
                    {{ api_data.Farmer.family_boy_school || '0' }}
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">{{ $t("Children") }} ({{ $t("Girl") }})</th>
            <td>
              <div class="input-group">
                <input type="number" class="form-control" v-model="api_data.Farmer.family_girl">
                <div class="input-group-append">
                  <div class="btn btn-warning" type="button">
                    {{ api_data.Farmer.family_girl || '0' }}
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">{{ $t("Children") }} ({{ $t("Girl") }} {{ $t("Play Group") }})</th>
            <td>
              <div class="input-group">
                <input type="number" class="form-control" v-model="api_data.Farmer.family_girl_playgroup"
                       :max="api_data.Farmer.family_girl"
                >
                <div class="input-group-append">
                  <div class="btn btn-warning" type="button">
                    {{ api_data.Farmer.family_girl_playgroup || '0' }}
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">{{ $t("Children") }} ({{ $t("Girl") }} {{ $t("School") }})</th>
            <td>
              <div class="input-group">
                <input type="number" class="form-control" v-model="api_data.Farmer.family_girl_school"
                       :max="api_data.Farmer.family_girl"
                >
                <div class="input-group-append">
                  <div class="btn btn-warning" type="button">
                    {{ api_data.Farmer.family_girl_school || '0' }}
                  </div>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import familyCount from "../familyCount";

export default {
  name: 'operation-family-information',
  components: {familyCount},
  props: {
    api_data: {
      type: Object,
      default: function () {
        return {};
      },
    },
  }
}
</script>
